import { Card, Flex, Heading, Progress, Text } from '@chakra-ui/react';
import { memo, useState } from 'react';

import Check from 'vectors/Check';

const Counter = () => {
  return <Text>1/5</Text>;
};

interface CheckListItemProps {
  step: Step;
}

const CheckListItem = ({ step }: CheckListItemProps) => {
  const { title, description, isCompleted, icon } = step;

  return (
    <Flex
      flexDir="row"
      gap={3}
      borderRadius="md"
      p={2}
      border="1px solid"
      borderColor="border.light"
      cursor={isCompleted ? 'disabled' : 'pointer'}
      _hover={isCompleted ? undefined : { bgColor: 'surface.hover' }}
      alignItems="center"
    >
      <Flex
        width="50px"
        height="50px"
        alignItems="center"
        justifyContent="center"
        alignContent="center"
        borderColor="border.light"
        borderRadius="md"
        borderWidth="1px"
        flexShrink={0}
      >
        {isCompleted ? <Check boxSize={4} color="green" /> : icon}
      </Flex>
      <Flex flexDir="column">
        <Text fontWeight="bold">{title}</Text>
        <Text>{description}</Text>
      </Flex>
    </Flex>
  );
};

interface Step {
  title: string;
  description: string;
  isCompleted?: boolean;
  icon?: React.ReactNode;
}

const checkListItems: Step[] = [
  {
    title: 'Create your business',
    description: 'Provide a name for your business',
    isCompleted: true,
  },
  {
    title: 'Complete your selling profile',
    description: 'Complete by providing essential information',
  },
  {
    title: 'Upload your logo',
    description: 'Upload a logo for your business',
  },
  {
    title: 'Build your inventory',
    description: 'Purchase charge stations and power banks',
  },
];

const CheckListCard = () => {
  const [progress, _] = useState(1);

  return (
    <Card.Root w="100%" bgColor="surface.background" borderColor="border.light" gap={2}>
      <Card.Header>
        <Flex justifyContent="space-between">
          <Heading size="sm"> Let&apos;s get you started</Heading>
          <Counter />
        </Flex>
      </Card.Header>
      <Progress.Root w="100%" value={(progress * 100) / checkListItems.length}>
        <Progress.Track h="4px">
          <Progress.Range />
        </Progress.Track>
      </Progress.Root>
      <Card.Body gap="2">
        {checkListItems.map((item) => (
          <CheckListItem key={item.title} step={item} />
        ))}
      </Card.Body>
    </Card.Root>
  );
};

export default memo(CheckListCard);
